import { render, staticRenderFns } from "./notificationsList.vue?vue&type=template&id=0d46b7e2&"
import script from "./notificationsList.vue?vue&type=script&lang=js&"
export * from "./notificationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports